import React, { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import {
//   MaterialReactTable,
//   useMaterialReactTable,
// } from "material-react-table";
import {
  useMaterialReactTable,
  MRT_ToggleFiltersButton,
  MRT_ShowHideColumnsButton,
  MRT_TableContainer,
} from 'material-react-table';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { API_URL } from "../../env";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataStockRep } from "../../Redux/ReportsData/StockReportDataSlice";

import dayjs from "dayjs";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { InputLabel } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, parse } from "date-fns";
import { enGB } from "date-fns/locale";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";

import ModalImage from "react-modal-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsLeftRight } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import { Box } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
config.autoAddCss = false;
const fontAwesomeIcons = {
  DragHandleIcon: () => (
    <FontAwesomeIcon
      icon={faArrowsLeftRight}
      style={{ paddingLeft: "5px", fontSize: "14px", color: "white" }}
    />
  ),
};

const CalculationTypeList = [
  {
    label: "Standard Cost",
    value: 1
  },
  {
    label: "Average Cost",
    value: 2
  },
  {
    label: "Last Purchase Cost",
    value: 3
  },
  {
    label: "FIFO",
    value: 4
  },
]

// const SummaryList = [
//   {
//     label: "Group Wise",
//     value: 1
//   },
//   {
//     label: "Quick Summary",
//     value: 2
//   },
//   {
//     label: "Summary",
//     value: 3
//   },
//   {
//     label: "Detail",
//     value: 4
//   },
// ]

export default function StockReport() {
  const Theme = useSelector((state) => state.Theme);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);
  const { result, status, error } = useSelector(
    (state) => state.StockReportData
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [Loader, setLoader] = useState(false);
  const [StockReportData, setStockReportData] = useState([]);
  const [MergedData, setMergedData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [IsWithAmount, setIsWithAmount] = useState(false);
  const [CalculationType, setCalculationType] = useState(0);
  // const [SummaryType, setSummaryType] = useState(1);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleExport = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const PhotoItem = ({ image, thumb }) => (
    <LightgalleryItem src={image} thumb={thumb} >
      <img
        className="insertImg"
        src={image}
        alt="img"
        style={{ width: "50px" }}
      />
    </LightgalleryItem>
  );

  const insertHiddenColmns = async () => {
    setLoader(true);
    var myHeaders = new Headers();
    const Token = localStorage.getItem("token");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Authorization", `Bearer ${Token}`);

    let positionObj = {};
    columnOrder?.map((item, index) => (positionObj[item] = index));

    var raw = CustomStringify({
      Hidd_Clm: columnVisibility,
      position: positionObj,
      Server: {
        Database: cmpdetail?.Database,
        Password: cmpdetail?.Password,
        Server: cmpdetail?.Server,
        User_ID: cmpdetail?.User_ID,
        Port: cmpdetail?.Port,
      },
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${API_URL}/StockRpt_InsertHiddenClm`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status === true) {
          setLoader(false);
          showToast("Saved Successfully", "success");
          setStockColumnVisibility(columnVisibility);
        } else {
          setLoader(false);
          showToast(result?.message, "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        showToast("API Error", "error");
        console.log(error);
      });
  };

  const exportToExcel = (rows) => {
    let ReorderedColumns = table
      .getState()
      .columnOrder?.map((columnId) => table.getColumn(columnId)?.columnDef);

    const tableData = rows?.map((row) =>
      Object.values(
        ReorderedColumns?.filter((item) => columnVisibility[item?.id]).reduce(
          (acc, c) => {
            if (c.id?.includes("Date")) {
              acc[c.id] =
                new Date(row.original[c.id])?.toLocaleDateString("en-GB") ==
                  "01/01/1"
                  ? ""
                  : new Date(row.original[c.id])?.toLocaleDateString("en-GB");
            } else {
              acc[c.id] = row.original[c.id];
            }
            return acc;
          },
          {}
        )
      )
    );
    const tableHeaders = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => c.header);

    const tableRows = tableData?.map((row) =>
      row?.map((value) => value).join(",")
    );

    const csvData = [tableHeaders.join(","), ...tableRows].join("\n");

    const blob = new Blob([csvData], { type: "text/csv" });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    if (CalculationType > 0) {
      a.download = `Stock_Report-(${CalculationTypeList?.filter((el) => el?.value == CalculationType)[0]?.label}).csv`;
    } else {
      a.download = "Stock_Report.csv";
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportToPDF = async (rows) => {
    const doc = new jsPDF({
      orientation: "landscape",
    });

    const xOffset = doc.internal.pageSize.width / 2;
    doc.setFontSize(12);
    const companyName = cmpdetail?.company_name ?? '';
    doc.text(companyName, xOffset, 8, { align: "center" });
    doc.setFontSize(10);

    const calcLabel = CalculationType > 0
      ? CalculationTypeList?.find(el => el?.value == CalculationType)?.label ?? ''
      : "Stock Report";

    doc.text(
      `Stock Report - (${calcLabel})`,
      xOffset,
      12,
      { align: "center" }
    );

    let ReorderedColumns = table
      .getState()
      .columnOrder?.map((columnId) => table.getColumn(columnId)?.columnDef);

    const imageColumnId = "imageUrl";

    const tableData = await Promise.all(
      rows.map(async (row) => {
        const rowData = {};
        for (const c of ReorderedColumns.filter((item) => columnVisibility[item?.id])) {
          if (c.id?.includes("Date")) {
            const dateStr = new Date(row.original[c.id])?.toLocaleDateString("en-GB") === "01/01/1"
              ? ""
              : new Date(row.original[c.id])?.toLocaleDateString("en-GB");
            rowData[c.id] = dateStr;
          } else if (c.id === imageColumnId) {
            const imageUrl = row.original[c.id];
            if (imageUrl) {
              rowData[c.id] = { content: "", raw: imageUrl[0] };
            } else {
              rowData[c.id] = { content: "", raw: null };
            }
          } else {
            rowData[c.id] = row.original[c.id];
          }
        }
        return Object.values(rowData);
      })
    );

    const tableHeaders = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => c.header ?? "");

    const tableFooters = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => {
      try {
        const footerContent = c?.Footer?.();
        const textValue = footerContent?.props?.children?.props?.children ?? "";
        return (typeof textValue === 'string' || typeof textValue === 'number') ? textValue : "";
      } catch {
        return "";
      }
    });

    const columnIndex = ReorderedColumns.findIndex(col => col.id === imageColumnId);
    autoTable(doc, {
      head: [tableHeaders],
      body: tableData,
      foot: [tableFooters],
      showHead: "firstPage",
      showFoot: "lastPage",
      theme: "striped",
      columnStyles: { text: { cellWidth: "auto" } },
      margin: { left: 3, right: 3 },
      styles: {
        overflow: "linebreak",
        cellWidth: "wrap",
        cellPadding: 1,
        fontSize: 6,
      },
      columnStyles: {
        [columnIndex]: { cellWidth: 20 }
      },
      autoWidth: true,

      didDrawCell: function (data) {
        if (data.row.section === 'body' && data.column.dataKey === columnIndex) {
          const base64Img = data.cell.raw?.raw;
          if (base64Img) {
            try {
              const imgProps = doc.getImageProperties(base64Img);

              const imgHeight = 10;
              const ratio = imgHeight / imgProps.height;
              const imgWidth = imgProps.width * ratio;

              if (data.cell.height < imgHeight) {
                data.row.height = imgHeight;
                data.cell.height = imgHeight;
              }

              // Center the image inside the cell
              const x = data.cell.x + (data.cell.width - imgWidth) / 2;
              const y = data.cell.y + (data.cell.height - imgHeight) / 2;

              const imgType = base64Img.startsWith("data:image/png") ? "PNG" : "JPEG";
              doc.addImage(base64Img, imgType, x, y, imgWidth, imgHeight);
            } catch (err) {
              console.warn("Invalid image, skipping cell.");
            }
          }
        }
      }
    });

    doc.save("Stock_Report.pdf");
  };

  // Helper function to convert image URL to base64
  const getBase64FromUrl = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.warn("Image fetch failed:", err);
      return null;
    }
  }
  const exportToJson = () => {
    const json = CustomStringify(FilteredData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Stock_Report.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  const [stockColumnVisibility, setStockColumnVisibility] = useState({
    supplier_design: true,
    imageUrl: true,
    design: true,
    desc: true,
    product: true,
    material: false,
    pattern: true,
    inward_qty: true,
    outward_qty: true,
    bal_qty: true,
  });
  const [columnVisibility, setColumnVisibility] = useState({
    supplier_design: true,
    imageUrl: true,
    design: true,
    desc: true,
    product: true,
    material: false,
    pattern: true,
    inward_qty: true,
    outward_qty: true,
    bal_qty: true,
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);

  const columns = [
    {
      accessorKey: "supplier_design",
      header: "Supply Design",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              Total Qty :{" "}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              Total MTRs :{" "}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "imageUrl",
      header: "Image",
      Cell: ({ cell }) => (
        cell.getValue() ?
          <LightgalleryProvider style={{ display: "flex", justifyContent: "center" }}>
            <PhotoItem image={cell.getValue()} />
          </LightgalleryProvider>
          :
          <></>
      ),
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              Total MTRs :{" "}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "design",
      header: "Design",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "desc",
      header: "Design Description",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "product",
      header: "Product",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "material",
      header: "Material",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "pattern",
      header: "Pattern",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "inward_qty",
      header: "Inward",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + Number(item.inward_qty), 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Inward, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "outward_qty",
      header: "Outward",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + Number(item.outward_qty), 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Outward, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "bal_qty",
      header: "Balance",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + Number(item.bal_qty), 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Balance, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
  ];

  // const handleSummary = (Type) => {
  //   var keys = Object.keys(columnVisibility);
  //   var Obj = {};

  //   if (Type == 1) {
  //     keys?.map((key) => {
  //       if (["DesignGroupName", "UnitName", "Opening", "Inward", "Outward", "Balance"].includes(key)) {
  //         Obj[key] = true
  //       } else {
  //         Obj[key] = false
  //       }
  //     })

  //   } else if (Type == 2) {
  //     keys?.map((key) => {
  //       if (["DesignGroupName", "DesignName", "ProductName", "DepartmentName", "PatternName", "UnitName", "Opening", "Inward", "Outward", "Balance"].includes(key)) {
  //         Obj[key] = true
  //       } else {
  //         Obj[key] = false
  //       }
  //     })

  //   } else if (Type == 3) {
  //     keys?.map((key) => {
  //       if (["DesignGroupName", "DesignName", "ProductName", "Sd_VType", "UnitName", "Opening", "Inward", "Outward", "Balance"].includes(key)) {
  //         Obj[key] = true
  //       } else {
  //         Obj[key] = false
  //       }
  //     })

  //   } else if (Type == 4) {
  //     Obj = stockColumnVisibility;

  //   }

  //   setColumnVisibility(Obj);
  // }


  const data = MergedData;

  const table = useMaterialReactTable({
    columns,
    data,
    // muiTableBodyRowProps: ({ row }) => ({
    //   onClick: (event) => {
    //     navigate(`/StockQuickSummary/${CalculationType}-${row?.original?.Sd_DesignGroupID}-${row?.original?.UnitName}`);
    //   },
    //   sx: {
    //     cursor: "pointer", //you might want to change the cursor too when adding an onClick
    //   },
    // }),
    icons: fontAwesomeIcons,
    // enableHiding: SummaryType == 4 ? true : false,
    enableHiding: true,
    enableColumnOrdering: true,
    enableBottomToolbar: false,
    enablePagination: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    // columnFilterDisplayMode: 'popover',
    enableSorting: false,
    enableGlobalFilter: false,
    initialState: { density: "compact" },
    muiTableContainerProps: {
      sx: {
        maxHeight: `calc(${"100vh"} - ${"100px"})`,
        "@media (max-width: 1150px)": {
          maxHeight: `calc(${"100vh"} - ${"140px"})`,
        },
        "@media (max-width: 768px)": {
          maxHeight: `calc(${"100vh"} - ${"180px"})`,
        },
      }
    },
    muiTableHeadCellProps: {
      sx: {
        bgcolor: Theme.primaryThemeColor,
        color: "#fff",
        "@media (max-width: 768px)": {
          padding: "2px 16px"
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        opacity: 0.9,
        border: "1px solid grey",
        "@media (max-width: 768px)": {
          fontSize: "13px",
          padding: "2px 16px"
        },
      },
    },
    muiTableFooterCellProps: {
      sx: {
        bgcolor: Theme.primaryThemeColor,
        color: "#fff",
        padding: 0,
        "@media (max-width: 768px)": {
          padding: "2px 16px"
        },
      },
    },
    muiColumnActionsButtonProps: {
      sx: {
        color: "#fff",
      },
    },
    muiFilterTextFieldProps: {
      placeholder: "Filter",
      sx: {
        background: "#fff",
        borderRadius: "5px",
        padding: "0px 3px",
      },
    },
    state: { columnVisibility, columnOrder, columnFilters },
    onColumnVisibilityChange: (state) => {
      return setColumnVisibility(state);
    },
    onColumnOrderChange: (state) => {
      return setColumnOrder(state);
    },
    onColumnFiltersChange: (state) => {
      return setColumnFilters(state);
    },
  });

  useEffect(() => {
    const mergedArray = StockReportData.reduce((accumulator, current) => {
      const existing = accumulator.find(
        (item) =>
          (columnVisibility.supplier_design
            ? item.supplier_design === current.supplier_design
            : true) &&
          (columnVisibility.imageUrl
            ? item.imageUrl === current.imageUrl
            : true) &&
          (columnVisibility.design
            ? item.design === current.design
            : true) &&
          (columnVisibility.desc
            ? item.desc === current.desc
            : true) &&
          (columnVisibility.product
            ? item.product === current.product
            : true) &&
          (columnVisibility.material
            ? item.material === current.material
            : true) &&
          (columnVisibility.pattern
            ? item.pattern === current.pattern
            : true)
      );

      if (existing) {
        existing.inward_qty += current.inward_qty;
        existing.outward_qty += current.outward_qty;
        existing.bal_qty += current.bal_qty;
      } else {
        accumulator.push({ ...current });
      }

      return accumulator;
    }, []);

    setMergedData(mergedArray);
  }, [columnVisibility, StockReportData]);

  useEffect(() => {
    const filteredRows = table.getFilteredRowModel().rows;
    const filteredData = filteredRows?.map((row) => row.original);
    setFilteredData(filteredData);
  }, [columnFilters, StockReportData]);

  useEffect(() => {
    if (state) {
      setCalculationType(state?.calId);
      setIsWithAmount(state?.calId > 0 ? true : false);
    } else {
      dispatch(fetchDataStockRep({ cmpdetail: cmpdetail, UserDetail: UserDetail }));
    }
  }, []);

  useEffect(() => {
    if (status === "loading") {
      setLoader(true);
    }
    else if (status === "succeeded") {
      setLoader(false);
      let Data = result?.data?.map((item) => {
        return {
          ...item,
          inward_qty: item?.inward_qty ? Number(item?.inward_qty).toFixed(2) : "",
          outward_qty: item?.outward_qty ? Number(item?.outward_qty).toFixed(2) : "",
          bal_qty: item?.bal_qty ? Number(item?.bal_qty).toFixed(2) : "",
          imageUrl: item?.images[0] ? `${API_URL}/files/${cmpdetail?.key}/${item?.images[0]}` : ""
        };
      });
      setStockReportData(Data);
      setMergedData(Data);
      setFilteredData(Data);

      // let sanitisedResult = (result) => {
      //   let obj = { ...result };
      //   delete obj.$id;
      //   delete obj.BarcodeNo;
      //   delete obj.Sd_Rate;
      //   delete obj.Sd_Amount;
      //   delete obj.Sd_Remark;
      //   delete obj.Sd_EntryDate;
      //   delete obj.Sd_ModifiedDate;
      //   delete obj.sd_lastStockLastInDate;
      //   delete obj.Sd_AmountBFT_ToT;
      //   delete obj.Sd_Amount_ToT;
      //   return obj;
      // }
      // setStockColumnVisibility(sanitisedResult(result?.data[0]?.HiddenColumns));
      // handleSummary(SummaryType);
      // let positionObj = sanitisedResult(result?.data[0]?.HiddenColumnPosition);
      // let positionArr = Object.keys(positionObj).sort(
      //   (a, b) => positionObj[a] - positionObj[b]
      // );
      // setColumnOrder(positionArr);
    } else if (status === "failed") {
      setLoader(false);
    }
  }, [status]);

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "500",
        fontSize: "20px",
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            maxWidth: "260px",
            height: "28px",
            padding: "12px 8px 12px 8px",
            fontWeight: 500,
            "@media (max-width: 768px)": {
              fontSize: "11px",
              padding: "10px 5px 10px 5px",
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            fontSize: "15px",
            "@media (max-width: 768px)": {
              fontSize: "13px",
            },
          },
        },
      },
    },
  });

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "15px",
            height: "32px",
            width: "150px",
            background: "#fff",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-10px",
          },
        },
      },
    },
  });

  return (
    <>
      <div
        className="main-box"
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <ThemeProvider theme={theme}>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={Loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="box-head-report">
            <Stack alignItems="center" direction="row">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(`/CompanyDashboard`);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h4">Stock Report</Typography>
            </Stack>
            {/* <Stack alignItems="center" direction="row">
              <FormControl>
                <InputLabel id="test-select-label">Summary Type</InputLabel>
                <Select
                  labelId="simple-select-label"
                  id="simple-select"
                  label="Summary Type"
                  value={SummaryType}
                  sx={{ width: "25vw", maxWidth: "200px", height: "30px", fontSize: "14px" }}
                  onChange={(event) => {
                    setSummaryType(event.target.value)
                    handleSummary(event.target.value)
                  }
                  }
                >
                  {SummaryList?.map((ele) => {
                    return (
                      <MenuItem value={ele?.value}>{ele?.label}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Stack> */}
            {/* <Stack className="middle" alignItems="center" direction="row" mx={1}>
              <FormControlLabel
                control={
                  <Switch
                    checked={IsWithAmount}
                    onChange={(event) => {
                      setIsWithAmount(event.target.checked)
                      if (event.target.checked) {
                        setCalculationType(1)
                        dispatch(fetchDataStockRep({ cmpdetail: cmpdetail, IsWithAmount: event.target.checked, CalculationType: 1 }))
                        setColumnVisibility((pre) => ({ ...pre, Sd_RateBFT: true, Sd_AmountBFT: true }))
                      } else {
                        setCalculationType(0)
                        dispatch(fetchDataStockRep({ cmpdetail: cmpdetail, IsWithAmount: event.target.checked, CalculationType: 0 }))
                        setColumnVisibility((pre) => ({ ...pre, Sd_RateBFT: false, Sd_AmountBFT: false }))
                      }
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                    size="small"
                  />
                }
                label="Is With Amount"
              />
              <FormControl sx={{ display: IsWithAmount ? "block" : "none" }}>
                <InputLabel id="test-select-label">Calculation Type</InputLabel>
                <Select
                  labelId="simple-select-label"
                  id="simple-select"
                  label="Calculation Type"
                  value={CalculationType}
                  sx={{ width: "25vw", maxWidth: "200px", height: "30px", fontSize: "14px" }}
                  onChange={(event) => {
                    setCalculationType(event.target.value)
                    dispatch(fetchDataStockRep({ cmpdetail: cmpdetail, IsWithAmount: IsWithAmount, CalculationType: event.target.value }))
                  }
                  }
                >
                  {CalculationTypeList?.map((ele) => {
                    return (
                      <MenuItem value={ele?.value}>{ele?.label}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Stack> */}
            <Stack className="btns" alignItems="center" direction="row">
              {/* {SummaryType == 4 && <Button onClick={insertHiddenColmns} variant="contained">
                <ViewWeekIcon sx={{ mr: 1, fontSize: "16px" }} /> Save Template
              </Button>} */}
              <Button onClick={handleExport} variant="contained">
                <SaveAltIcon sx={{ fontSize: "16px" }} />
              </Button>
              <MRT_ToggleFiltersButton table={table} />
              <MRT_ShowHideColumnsButton table={table} />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => (
                    exportToExcel(table.getPrePaginationRowModel().rows),
                    handleClose()
                  )}
                >
                  Download Excel
                </MenuItem>
                <MenuItem
                  onClick={() => (
                    exportToPDF(table.getPrePaginationRowModel().rows), handleClose()
                  )}
                >
                  Download PDF
                </MenuItem>
                <MenuItem onClick={() => (exportToJson(), handleClose())}>
                  Download JSON
                </MenuItem>
              </Menu>
            </Stack>
          </div>
          <MRT_TableContainer table={table} />
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MaterialReactTable table={table} />
          </LocalizationProvider> */}
        </ThemeProvider>
      </div>
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
